import german from '../../../../../../locales/german.json';
import englisch from '../../../../../../locales/englisch.json';
import french from '../../../../../../locales/french.json';
import dutch from '../../../../../../locales/dutch.json';
import greek from '../../../../../../locales/greek.json';

// Same locale files the client checkout bundles: the preview must render the
// exact strings the live checkout shows for the selected language pill.
// Keys here mirror LANGS in editCheckoutProfile.vue / langMap in client App.vue.
const LANG_FILES = { de: german, en: englisch, fr: french, nl: dutch, el: greek };

/**
 * Mixin for checkout-step previews (requires a `lang` prop): resolves the
 * active language pill to its locale dictionary so all non-profile ("static")
 * checkout text follows the language switch, just like the real checkout.
 */
export default {
  computed: {
    /** Locale dictionary for the preview's active language. */
    LF() { return LANG_FILES[this.lang] || LANG_FILES.de; }
  },
  methods: {
    /** Localized checkout string; fallback mirrors the client-side default. */
    t(key, fallback) { return this.LF[key] || fallback; }
  }
};
